import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/ui/Header";
import { SidebarProvider, SidebarTrigger } from "../components/ui/sidebar";
import { AppSidebar } from "pages/dashboard/components/AppSidebar";

const AppLayout = () => {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full overflow-hidden bg-background">
        <AppSidebar />
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto">
            <Suspense
              fallback={
                <div className="p-8 text-muted-foreground text-sm">
                  Loading...
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default AppLayout;
